import Confetti from "react-confetti";
import { useWindowSize } from "react-use";
import "./styles.css";

const PLAY_STORE_URL =
  "https://upload.wikimedia.org/wikipedia/commons/7/78/Google_Play_Store_badge_EN.svg";
const APP_STORE_URL =
  "https://upload.wikimedia.org/wikipedia/commons/3/3c/Download_on_the_App_Store_Badge.svg";

const Success = () => {
  const { width, height } = useWindowSize();

  return (
    <div className="success-container">
      <Confetti
        width={width}
        height={height}
        recycle={false}
        numberOfPieces={500}
        gravity={0.15}
      />

      <div className="success-card">
        <div className="success-icon-wrapper">
          <svg
            className="success-icon"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 52 52"
          >
            <circle
              className="success-icon-circle"
              cx="26"
              cy="26"
              r="25"
              fill="none"
            />
            <path
              className="success-icon-check"
              fill="none"
              d="M14.1 27.2l7.1 7.2 16.7-16.8"
            />
          </svg>
        </div>

        <h1 className="success-title">Ticket Confirmed!</h1>
        <p className="success-message">
          Your tickets can be viewed on the Ōta Life App
        </p>

        <div className="app-buttons">
          <a
            href="https://play.google.com/store/apps/details?id=com.otanative.ota"
            target="_blank"
            rel="noopener noreferrer"
            className="app-button"
          >
            <img
              src={PLAY_STORE_URL}
              alt="Get it on Google Play"
              className="store-badge"
            />
          </a>

          <a
            href="https://apps.apple.com/in/app/ota-life/id6743555476"
            target="_blank"
            rel="noopener noreferrer"
            className="app-button"
          >
            <img
              src={APP_STORE_URL}
              alt="Download on the App Store"
              className="store-badge"
            />
          </a>
        </div>

        <div className="note-box">
          <span className="note-label">NOTE:</span> PLEASE LOGIN WITH THE SAME
          EMAIL ON APP WHICH YOU USED TO PURCHASE THE TICKET
        </div>

        <div className="how-to-section">
          <h2 className="how-to-title">How to Access Your Tickets</h2>
          <div className="steps-container">
            <div className="step">
              <div className="step-number">1</div>
              <div className="step-content">
                <img
                  src="https://cdn.otalife.app/1763124137100_ticket1.jpeg.jpg"
                  alt="Navigate to My Profile"
                  className="step-screenshot"
                />
                <p className="step-description">
                  Open the app and navigate to <strong>My Profile</strong> tab
                </p>
              </div>
            </div>

            <div className="step">
              <div className="step-number">2</div>
              <div className="step-content">
                <img
                  src="https://cdn.otalife.app/1763124152883_ticket2.jpeg.jpg"
                  alt="Open My Purchase"
                  className="step-screenshot"
                />
                <p className="step-description">
                  Tap on <strong>My Purchase</strong> to view your tickets
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
